import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { CatalogViewComponentDef } from '@df/catalog-ui/catalog-view.component.def';
import { ICategoryDataV3 } from '@df/catalog/category/category';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { IProductDataV3 } from '@df/catalog/product/product';
import { GiftcardsProductViewComponent } from '../../module/giftcards/giftcards-product-view.component';
import { LocalCategory } from '../model/category/category.decorator';
import { LocalProduct } from '../model/product/product.decorator';
import { CategoryViewComponent } from './category/category-view.component';
import { Error404Component } from './error-404.component';
import { LocalPage } from './page/component/page.decorator';
import { PageViewComponent } from './page/page-view.component';
import { ProductViewComponent } from './product/product-view.component';

@Component({
    selector: 'catalog-view',
    templateUrl: 'catalog-view.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        forwardRef(() => PageViewComponent),
        forwardRef(() => CategoryViewComponent),
        GiftcardsProductViewComponent,
        ProductViewComponent,
        Error404Component
    ]
})
export class CatalogViewComponent extends CatalogViewComponentDef {
    protected get productModel(): LocalProduct<IProductDataV3> {
        return this.model as LocalProduct<IProductDataV3>;
    }

    protected get pageModel(): LocalPage<IPageDataV3> {
        return this.model as LocalPage<IPageDataV3>;
    }

    protected get categoryModel(): LocalCategory<ICategoryDataV3> {
        return this.model as LocalCategory<ICategoryDataV3>;
    }
}
